import React, { forwardRef, useEffect, useRef } from "react";
import useLang from "../../hooks/useLanguage";
import MuiSkeleton from "../MuiSkeleton";
import { useLocation } from "react-router-dom";

interface InputProps {
  type?: string;
  label?: string;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  parentDivClassName?: string;
  placeholder?: string;
  value?: any;
  error?: string;
  required?: boolean;
  mask?: string;
  loading?: boolean;
  maxLength?: number;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  maxLengthValue?: number;
  disabled?: boolean;
  max?: string;
  length?: number;
  errorFocussedInput?: any;
  sectionId?: any;
  ArrayReqId?: any;
  disablessn?: any;
  fieldIndex: any;
  setDisableSSN?: any;
  Inputs: any;
  index: any;
  setErrorFocussedInput?: any;
  systemFieldName?: string;
  validationBackup?: any;
  setValidationBackup?: any;
  setInputs?: (inputs: any) => void;
  editID?: any;
}

const SSNNumberWithText = forwardRef<HTMLInputElement, InputProps>(
  (props: any, ref: any) => {

    const location = useLocation();
    console.log(location?.state, "location?.state?.reqId")
    const validationExpressionLocalRef = useRef<Record<string, string>>({});

    const findFieldBySystemFieldName = (): any | null => {
      const section = props.Inputs?.[props?.index];
      if (!section || !props.systemFieldName) return null;
      const inFields = section.fields?.find(
        (f: any) => f.systemFieldName === props.systemFieldName
      );
      if (inFields) return inFields;
      for (const dep of section.dependencyControls || []) {
        const found = dep.dependecyFields?.find(
          (f: any) => f.systemFieldName === props.systemFieldName
        );
        if (found) return found;
      }
      return null;
    };

    const handleChange = (e: any) => {
      const checked = e.target.checked;
      const sf = props.systemFieldName as string | undefined;
      const field = findFieldBySystemFieldName();

      if (checked) {
        const currentExpr = field?.validationExpression ?? "";
        if (sf) {
          if (props.setValidationBackup) {
            props.setValidationBackup((prev: any) => {
              const list = Array.isArray(prev) ? prev : [];
              return [
                ...list.filter((b: any) => b.systemFieldName !== sf),
                {
                  systemFieldName: sf,
                  validationExpression: currentExpr,
                },
              ];
            });
          } else {
            validationExpressionLocalRef.current[sf] = currentExpr;
          }
        }
        if (field) field.validationExpression = "";
        props.setDisableSSN(true);
        if (field) {
          field.defaultValue = "";
          field.enableRule = "";
        };
      } else {
        let restored = "";
        if (sf) {
          if (
            props.setValidationBackup &&
            Array.isArray(props.validationBackup)
          ) {
            const backup = props.validationBackup.find(
              (b: any) => b.systemFieldName === sf
            );
            if (backup) restored = backup.validationExpression ?? "";
          } else if (validationExpressionLocalRef.current[sf] !== undefined) {
            restored = validationExpressionLocalRef.current[sf];
          }
        }
        if (field) field.validationExpression = restored;
        props.setDisableSSN(false);
      }

      props.setInputs?.([...props.Inputs]);
    };

    const ssnFieldDefaultValue = findFieldBySystemFieldName()?.defaultValue;
    const field = findFieldBySystemFieldName();
    const currentExpr = field?.validationExpression ?? "";
    useEffect(() => {

      if (!ssnFieldDefaultValue) {
        props.setDisableSSN(false);
      }
    }, [ssnFieldDefaultValue]);

    const { t } = useLang();
    const divElement = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
      if (props.error && divElement.current) {
        divElement.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      props.setErrorFocussedInput && props.setErrorFocussedInput();
    }, [props?.errorFocussedInput]);
    useEffect(() => {
      if (location?.state?.reqId && props.value === "" || props?.editID && props.value === "") {
        props.setDisableSSN(true);
        const sf = props.systemFieldName as string | undefined;
        if (sf) {
          if (props.setValidationBackup) {
            props.setValidationBackup((prev: any) => {
              const list = Array.isArray(prev) ? prev : [];
              return [
                ...list.filter((b: any) => b.systemFieldName !== sf),
                {
                  systemFieldName: sf,
                  validationExpression: currentExpr,
                },
              ];
            });
          }
        }
        if (field) field.validationExpression = "";


      }
    }, [props.value, props.systemFieldName]);
    return (
      <div
        className={
          props?.parentDivClassName
            ? `${props?.parentDivClassName} mb-4`
            : "col-lg-6 col-md-6 col-sm-12 mb-4"
        }
      >
        <label
          className={
            props?.required && !props?.disablessn
              ? "required mb-2 fw-500"
              : "mb-2 fw-500"
          }
          htmlFor={props.id}
        >
          {t(props.label)}
        </label>
        {props?.loading ? (
          <MuiSkeleton />
        ) : (
          <>
            <input
              value={props?.value}
              placeholder={props.placeholder}
              type={props?.type ?? "text"}
              pattern={props?.pattern}
              max={props.max}
              name={props.name}
              id={props.id}
              autoComplete="off"
              onChange={(e: any) => {
                props.onChange(e);
                props.setDisableSSN(false);
              }}
              onBlur={props.onBlur}
              className={`${props.className} form-control ${props?.disablessn ? "bg-secondary" : "bg-transparent"
                }`}
              disabled={props?.disablessn}
              maxLength={props?.length}
              required={props.required && !props?.disablessn}
              ref={ref}
              onKeyDown={props.onKeyDown}
            />
            {props.error && (
              <div className="form__error">
                <span>{t(props.error)}</span>
              </div>
            )}
            <div className="mt-2">
              <label className="form-check form-check-inline form-check-solid m-0 d-flex align-items-center gap-2">
                <input
                  className="form-check-input h-15px w-15px rounded-01"
                  type="checkbox"
                  onChange={handleChange}
                  checked={props?.disablessn}
                />
                <span className="text-gray-600 fs-7">{props.label} Not Required</span>
              </label>
            </div>
          </>
        )}
      </div>
    );
  }
);

export default SSNNumberWithText;
